import { Injectable } from '@angular/core';
import { BehaviorSubject, map, take, tap } from 'rxjs';
import { DropdownMenu } from 'src/app/models/app/dropdown-menu.model';
import { Page } from 'src/app/models/data/page.model';
import { EthnicService } from '../ethnic/ethnic.service';
import { PageService } from '../page/page.service';
import { ReviewSurveyService } from '../review-survey/review-survey.service';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  open = new BehaviorSubject<boolean>(false);
  surveyPage = new BehaviorSubject<boolean>(false);
  pages: Page[] = [];
  surveyNavigationList = new BehaviorSubject<DropdownMenu[]>([]);
  surveyNavigationListTemp: DropdownMenu[] = [];
  pageNav = [
    {
      name: 'Survey',
      route: '', // Will be set dynamically from API via updateSurveyRoute()
    },
    // {
    //   name: 'FRQ',
    //   route: '/frq/0',
    // },
  ];



  constructor(
    private pageService: PageService,
    private ethnicService: EthnicService,
    private reviewService: ReviewSurveyService,
  ) {
    // Load navigation from API instead of hardcoded array
    this.loadNavigationFromAPI();
  }


  // New method to load navigation from API
  loadNavigationFromAPI(): void {
    this.pageService.fetchPages();

    this.pageService.pages.subscribe((pages: Page[]) => {
      if (pages.length > 0) {
        // Update Survey link to first page
        this.updateSurveyRoute(pages);

        // Sort by pageNumber to ensure correct order
        const sortedPages = pages.sort((a, b) => a.PageNumber - b.PageNumber);

        // Transform Page[] to DropdownMenu[]
        const navigationItems: DropdownMenu[] = sortedPages.map(page => {
          // Add leading slash to route from API
          const route = page.Route.startsWith('/') ? page.Route : `/${page.Route}`;
          const menuItem = new DropdownMenu(page.Title, route, page.PageNumber);
          menuItem.Completed = page.Valid;
          return menuItem;
        });

        this.questionDropwdown = navigationItems;
        this.surveyNavigationList.next(navigationItems);
        // Store pages for later reference
        this.pages = pages;
      }
    });
  }



  changeState() {
    if (this.open.value == false) {
      this.open.next(true);
    } else {
      this.open.next(false);
    }
  }

  closeSidebar() {
    this.open.next(false);
  }

  openSidebar() {
    this.open.next(true);
  }

  // Navigation items loaded from API - no longer hardcoded
  private questionDropwdown: DropdownMenu[] = [];


  getQuestionDropdown() {
    return this.questionDropwdown.slice();
  }

  updateSurveyRoute(pages: Page[]): void {
    console.log('📋 UPDATE SURVEY ROUTE DEBUG: Called with', pages?.length || 0, 'pages');
    if (pages && pages.length > 0) {
      const firstPage = pages[0];
      const route = firstPage.Route.startsWith('/') ? firstPage.Route : `/${firstPage.Route}`;
      console.log('📋 UPDATE SURVEY ROUTE DEBUG: First page Route from API:', firstPage.Route);
      console.log('📋 UPDATE SURVEY ROUTE DEBUG: Setting navbar survey route to:', route);
      const oldRoute = this.pageNav[0]?.route;
      this.pageNav[0].route = route;
      console.log('📋 UPDATE SURVEY ROUTE DEBUG: Navbar route updated from', oldRoute, 'to', route);
      console.log('📋 UPDATE SURVEY ROUTE DEBUG: Current pageNav:', JSON.stringify(this.pageNav));
    } else {
      console.log('📋 UPDATE SURVEY ROUTE DEBUG: No pages provided, survey route not updated');
    }
  }

  setPageCompletionStatuses(): void {
    // Check if user is authenticated before making API calls
    const userString = localStorage.getItem('user');
    if (!userString) {
      // No user in localStorage, skip page status update
      return;
    }

    // Fetch fresh page data from API
    this.pageService.fetchPages().subscribe((pages: Page[]) => {
      if (pages.length > 0) {
        // Sort by pageNumber to ensure correct order
        const sortedPages = pages.sort((a, b) => a.PageNumber - b.PageNumber);

        // Update existing navigation items with fresh completion status
        this.questionDropwdown.forEach(navItem => {
          const correspondingPage = sortedPages.find(page => {
            const pageRoute = page.Route.startsWith('/') ? page.Route : `/${page.Route}`;
            return pageRoute === navItem.Route;
          });

          if (correspondingPage) {
            navItem.Completed = correspondingPage.Valid;
          }
        });

        // Update the pages array
        this.pages = pages;

        // Emit the updated navigation list immediately after updating completion statuses
        this.surveyNavigationList.next([...this.questionDropwdown]);

        // Keep existing review completion check (uses different endpoint)
        // Only call if we have navigation items (user is authenticated)
        if (this.questionDropwdown.length > 0) {
          this.reviewService.checkCompleted().subscribe((res) => {
            if (res) {
              const reviewItem = this.questionDropwdown.find(item => item.Route === '/submit-survey');
              if (reviewItem) {
                reviewItem.Completed = res.completed;
                // Emit again if review status changed
                this.surveyNavigationList.next([...this.questionDropwdown]);
              }
            }
          });
        }
      }
    });
  }

}
